import {
    Autocomplete,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useEffect } from "react";
import { useSelector } from "src/stateManagement/redux";

export const projects = [
    {
        id: "LB",
        label: "Bachaquero Tierra",
        projectId: "e8de6828-b7db-11ef-bebc-22937bb103f9",
    },
    {
        id: "LS",
        label: "Lagunillas Tierra",
        projectId: "e6c51ece-b7db-11ef-bebc-22937bb103f9",
    },
];

const types = [
    {
        id: "requirement",
        label: "Requerimiento",
    },
];

const status = [
    {
        id: "Pending",
        label: "Pendiente",
    },
    {
        id: "inProgress",
        label: "En Progreso",
    },
    {
        id: "analyzing",
        label: "Analizando",
    },
    {
        id: "completed",
        label: "Completado",
    },
    {
        id: "discarded",
        label: "Descartado",
    },
    {
        id: "blocked",
        label: "Bloqueado",
    },
];

interface Props {
    TabDisable: boolean;
    requiredUserId: string;
    handleInputChange: any;
    elementsWithErrors: string[];
}

export const HeaderAddRequirements = ({
    TabDisable,
    requiredUserId,
    handleInputChange,
    elementsWithErrors
}: Props) => {
    const { field, locationName } = useSelector((state) => state.location);
    const { users } = useSelector((state) => state.gerenciaTecnica);

    useEffect(() => {
        console.log({requiredUserId})
    }, [requiredUserId])
    

    return (
        <Grid container spacing={2}>
            <Grid size={3}>
                <TextField
                    fullWidth
                    size="medium"
                    label="Proyectos"
                    value={field}
                    disabled
                    onChange={(e) => {}}
                />
            </Grid>
            <Grid size={3}>
                <TextField
                    fullWidth
                    size="medium"
                    label="Locación"
                    value={locationName}
                    disabled
                    onChange={(e) => {}}
                />
            </Grid>
            <Grid size={3}>
                <FormControl fullWidth error={elementsWithErrors.includes("requiredUserId")}>
                    <InputLabel id="demo-simple-select-label">
                        Requerido por
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={requiredUserId}
                        name="requiredUserId"
                        label="Requerido por"
                        fullWidth
                        onChange={handleInputChange}
                    >
                        {users!.map((user: any, index: number) => (
                            <MenuItem value={user.id} key={index}>
                                {user.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={3}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={types[0].id}
                        name="type"
                        label="Tipo"
                        fullWidth
                        onChange={handleInputChange}
                    >
                        {types!.map((type: any, index: number) => (
                            <MenuItem value={type.id} key={index}>
                                {type.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={3}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                        Status
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={status[0].id}
                        name="status"
                        label="Status"
                        fullWidth
                        onChange={handleInputChange}
                        disabled={TabDisable}
                    >
                        {status!.map((status: any, index: number) => (
                            <MenuItem value={status.id} key={index}>
                                {status.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={3}>
                <DesktopDatePicker
                    defaultValue={moment()}
                    label="Fecha Requerida"
                    disabled={TabDisable}
                    sx={{
                        width: "100%",
                    }}
                />
            </Grid>
            <Grid size={3}>
                <Autocomplete
                    disablePortal
                    fullWidth
                    size="medium"
                    options={projects}
                    renderInput={(params) => (
                        <TextField {...params} label="Planificada" />
                    )}
                    sx={TabDisable ? { display: "none" } : {}}
                />
            </Grid>
            <Grid size={3}>
                <Autocomplete
                    disablePortal
                    fullWidth
                    size="medium"
                    options={projects}
                    renderInput={(params) => (
                        <TextField {...params} label="Ejecutado" />
                    )}
                    sx={TabDisable ? { display: "none" } : {}}
                />
            </Grid>
        </Grid>
    );
};
